/* @flow weak */
import PaymentHeaderActions from 'rsvp/actions/PaymentHeaderActions';
import React from 'react';

/**
 * This component allows the component it wraps to pass an event screen
 * name through to the PaymentHeader so that clicking the 'Sign In' or
 * 'Log Out' button on a particular screen in a flow can be logged.
 */
export default function connectPaymentHeaderEventScreenName(Component) {
  const wrapper = React.createClass({
    propTypes: {
      eventScreenName: React.PropTypes.string,
    },

    componentDidMount() {
      const screenName = this.props.eventScreenName;
      if (screenName) {
        PaymentHeaderActions.setEventScreenName(screenName);
      }
    },

    componentWillUnmount() {
      PaymentHeaderActions.setEventScreenName(null);
    },

    render() {
      return (
        <Component
          {...this.props}
          {...this.state}
        />
      );
    },
  });

  return wrapper;
}



// WEBPACK FOOTER //
// ./src/payments/utils/connectPaymentHeaderEventScreenName.js